import { createRequest, getError } from "Utils/requestUtils";
import { call, put, takeLatest } from "redux-saga/effects";
import { OperationType, VeteranModel } from "./interfaces";
import {
  getVeteranVehicleModelStart,
  getVeteranVehicleModelSucceded,
  operationFailed,
} from "./slice";

import { VeteranAutoType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/VeteranAuto";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* getVeteranVehicleModel({
  payload,
}: ReturnType<typeof getVeteranVehicleModelStart>) {
  try {
    const { data } = yield call(createRequest, {
      method: "get",
      url: `/open/insurance/vehicle/veteranauto/${payload.vehicleType}`,
    });
    yield put(
      getVeteranVehicleModelSucceded({
        models: data.models as VeteranModel[],
      }),
    );
  } catch (e) {
    yield put(
      operationFailed({
        error: {
          operationType: getVeteranVehicleModelOperationType(
            payload.vehicleType,
          ),
          response: getError(e),
        },
      }),
    );
  }
}

export function* getVeteranVehicleModelSaga(): Generator {
  yield takeLatest(getVeteranVehicleModelStart, getVeteranVehicleModel);
}

const getVeteranVehicleModelOperationType = (
  vehicleType: VeteranAutoType,
): OperationType => {
  switch (vehicleType) {
    case VeteranAutoType.VETERANBIL:
      return OperationType.GET_VETERAN_AUTO_MODELS;
    case VeteranAutoType.VETERANMOPED:
      return OperationType.GET_VETERAN_MOPED_MODELS;
    case VeteranAutoType.VETERANMOTORSYKKEL:
    default:
      return OperationType.GET_VETERAN_MOTORCYCLE_MODELS;
  }
};
